import { render, staticRenderFns } from "./BatchAssignSale.vue?vue&type=template&id=73b740d8&scoped=true&"
import script from "./BatchAssignSale.vue?vue&type=script&lang=js&"
export * from "./BatchAssignSale.vue?vue&type=script&lang=js&"
import style0 from "./BatchAssignSale.vue?vue&type=style&index=0&id=73b740d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b740d8",
  null
  
)

export default component.exports